import { useContext, useState } from 'react';
// 组件
import {
  LogoutOutlined,
  KeyOutlined,
  DownOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { ProDropdown, ProAvatar } from '../../../antd';
import ChangePassword from './subpage/ChangePassword';
// 方法
import { useNavigate } from 'react-router-dom';
import LayoutContext from '../../../PageLayout/context/LayoutContext';
import { routeNameToBasePath } from '../../../utils/utils';
import { setAppLicationInfo } from '../../../utils/loginUtils';
// 常量
import { MenuProps } from 'antd';
import { SUCCESS_STATUS_CODE } from '../../../constants/constant';
import { APPLICATION_INFO_KEY } from '../../../constants/localStorage';
import styles from './style.module.less';

const MenuItems: MenuProps['items'] = [
  // {
  //   key: 'userCenter',
  //   icon: <UserOutlined />,
  //   label: '个人中心',
  // },
  // {
  //   key: 'changePassword',
  //   icon: <KeyOutlined />,
  //   label: '修改密码',
  // },
  {
    key: 'logout',
    icon: <LogoutOutlined />,
    label: '退出登录',
  },
];

const UserDropdown: React.FC = () => {
  const [menuItems, setMenuItems] = useState<MenuProps['items']>(MenuItems);
  const { userInfo, dispatch } = useContext(LayoutContext);
  const navigate = useNavigate();
  const pathname = window.location.pathname;
  const handleClick = (itemKey: string) => {
    const findItem: any = menuItems?.find(item => item?.key === itemKey);
    if (!findItem) return;
    const { key, isAdmin, } = findItem;
    // 管理员应用
    if (isAdmin) {
      window.localStorage.setItem(APPLICATION_INFO_KEY, setAppLicationInfo(findItem));
      window.location.href = `${window.location.origin}/${findItem.urlPrefix}/`;
      return;
    }
    // 其他
    if (key === 'userCenter') {
      if (pathname.startsWith('/userView')) {
        navigate('/userView/userCenter', { replace: true, });
        return;
      }
      navigate(`/${routeNameToBasePath(pathname)}/user/userCenter`);
      return;
    }
    if (key === 'logout') {
      dispatch('logout');
      return;
    }
    if (key === 'changePassword') {
      dispatch('changeGlobal', { changePassword: true });
      return;
    }
  };

  return (
    <>
      <ProDropdown
        menu={{
          onClick: item => handleClick(item.key),
          items: menuItems,
        }}
      >
        <div className={styles.dropdown}>
          {userInfo && (
            <>
              <ProAvatar size="small" src={userInfo.avatar} />
              <span>{userInfo.name}</span>
            </>
          )}
          <DownOutlined />
        </div>
      </ProDropdown>
      <ChangePassword />
    </>
  );
};

export default UserDropdown;
